import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { Alert } from "react-bootstrap";
import { translate } from "../../core/i18n";
import { getDomainCfg } from "../../core/state";
import { getCloudUser } from "../../features/cloudstorage/cloud";
import { getFileContent } from "../../features/http";
import { createQRCode } from "../../features/qrcode";

export function ShareInfo(props: { shareState : any, shown : boolean, loggedIn : boolean }) {
  const [mailBody, setMailBody] = useState("");
  const cloudUser = getCloudUser();
  const url = props.shareState?.url;

  useEffect( () => {
    const createMailBody = async () : Promise<void> => {
      const mailContent = await getFileContent(getDomainCfg().product.shareMailBody);
      if (!mailBody) {
        setMailBody(mailContent);
      }
    }
    if (props.shown)  {
      createMailBody();
    }

  })

  if (props.shareState?.sharingStatus === "public") {
    const qrCode = createQRCode(url, 0, "L", "Byte");
    const mail = mailBody.replace("{url}", url).replace("{user}",cloudUser.userName);
    const mailSubject = translate("share-mail-subject", getDomainCfg().product.name);
    const mailLink = `mailto:?body=${encodeURI(mail)}&subject=${mailSubject}`

    return (
      <>
        <hr />
        <div className="row">
          <div className="col-sm-12">
            <h4>{ translate("share-status-public-link") }</h4>
            <small> { translate("share-status-public-hint") } </small>
            <input type="text" className="form-control project-share-url" value={url} aria-describedby="url" placeholder="Project URL" readOnly />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <h5>{ translate("share-status-mobile") }</h5>
            <div id="qr-code" className="text-center" dangerouslySetInnerHTML={{ __html : qrCode }} />
          </div>
          <div className="col-sm-6">
            <div className="row">
              <div className="col-sm-12">
                <h5>{ translate("share-status-mail") }</h5>
                <a className="btn btn-primary m-1 btn-lg btn-block" href={mailLink}><FontAwesomeIcon icon="envelope" /> { translate("share-status-mail-action") }</a>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  } else if (props.shareState?.sharingStatus === "private") {
    if (!props.loggedIn) {
      return <Alert variant="warning">{translate('share-status-unavailable')}</Alert>;
    }
  }
  return null;
}
